import React from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Text, TextType } from 'ui-components/components/text';
import { emptyObject } from 'ui-components/default-props/empty';

import FormattedCurrency from '../../../../../components/formatted-currency/container';
import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';
import { CurrencyPropType } from '../../../../../prop-types/currency';
import messages from '../messages';

import style from '../style.module.less';

const ItemTotalColumnId = 'costTotal';

/**
 * @typedef {object} TotalPriceData
 * @property {string} code - The currency code of the total price.
 * @property {number | string} value - The value of the total price, can be a number or a string that can be parsed into a number.
 * @property {boolean} [allowNegative] - Whether to allow negative values, if false the absolute value will be displayed.
 */

/**
 * @param {{ totalPrice: TotalPriceData }} item
 * @returns {TotalPriceData}
 */
const itemTotalDataBuilder = (item) => {
  return item.totalPrice;
};

const ItemTotalCell = ({ cell }) => {
  const { code, value, allowNegative = false } = cell.value || emptyObject;

  let currencyValue = value ? parseFloat(value) : 0;

  if (!allowNegative) {
    currencyValue = Math.abs(currencyValue);
  }

  return <Text element='span' textType={TextType.Description} value={<FormattedCurrency currencyCode={code} value={currencyValue} />} />;
};

ItemTotalCell.propTypes = {
  cell: PropTypes.shape({
    value: CurrencyPropType,
  }).isRequired,
};

const createItemTotalColumnDefinition = createColumnDefinitionBuilder({
  Header: <FormattedMessage {...messages.itemTotal} />,
  accessor: ItemTotalColumnId,
  Cell: ItemTotalCell,
  width: 1,
  className: style['justify-end'],
});

export { ItemTotalColumnId, itemTotalDataBuilder, createItemTotalColumnDefinition };
